webpackJsonp([10],{

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(779),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selection-btn',
  props: ['value']
});

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".title-btn{float:left;font-size:16px;margin-right:10px;color:#64696c}.selection-btn{float:left;cursor:pointer;width:65px;height:25px;position:relative;border-radius:4px;padding-top:2px;background-color:#a3a3a3;-webkit-transition:background-color .5s;transition:background-color .5s}.selection-btn:before{content:\"N\\C3O\";color:#fff;padding-left:28px;display:block;position:absolute;height:100%;-webkit-transition:transform .5s;-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.selection-btn.isActive{background:#5ebc61}.selection-btn.isActive:before{content:\"SIM\";padding-left:8px}.selection-btn:after{content:\" \";background-color:#fff;padding-left:10px;display:block;height:20px;width:20px;border-radius:4px;-webkit-transform:translate(5px);transform:translate(5px);-webkit-box-shadow:0 0 2px #848484;box-shadow:0 0 2px #848484;-webkit-transition:transform .3s;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.selection-btn.isActive:after{-webkit-transform:translate(40px);transform:translate(40px)}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/SelectionBtn.vue"],"names":[],"mappings":"AACA,WACE,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,eACE,WAAY,AACZ,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,kBAAkB,AAClB,kBAAmB,AACnB,gBAAgB,AAChB,yBAAyB,AACzB,wCAAyC,AACzC,+BAAiC,CAClC,AACD,sBACE,gBAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,kBAAkB,AAClB,YAAa,AACb,iCAAkC,AAClC,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,8CAAiD,CAClD,AACD,wBACE,kBAAmB,CACpB,AACD,+BACI,cAAe,AACf,gBAAkB,CACrB,AACD,qBACE,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,WAAY,AACZ,kBAAkB,AAClB,iCAAkC,AAC1B,yBAA0B,AAClC,mCAAoC,AAC5B,2BAA4B,AACpC,iCAAkC,AAClC,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,8CAAiD,CAClD,AACD,8BACE,kCAAmC,AAC3B,yBAA2B,CACpC","file":"SelectionBtn.vue","sourcesContent":["\n.title-btn{\n  float: left;\n  font-size: 16px;\n  margin-right: 10px;\n  color: #64696c;\n}\n.selection-btn{\n  float: left;\n  cursor: pointer;\n  width: 65px;\n  height: 25px;\n  position:relative;\n  border-radius: 4px;\n  padding-top:2px;\n  background-color:#a3a3a3;\n  -webkit-transition: background-color .5s;\n  transition: background-color .5s;\n}\n.selection-btn::before{\n  content: 'NÃO';\n  color: #fff;\n  padding-left: 28px;\n  display: block;\n  position:absolute;\n  height: 100%;\n  -webkit-transition: transform .5s;\n  -webkit-transition: -webkit-transform .5s;\n  transition: -webkit-transform .5s;\n  transition: transform .5s;\n  transition: transform .5s, -webkit-transform .5s;\n}\n.selection-btn.isActive{\n  background:#5ebc61;\n}\n.selection-btn.isActive::before{\n    content: 'SIM';\n    padding-left: 8px;\n}\n.selection-btn::after{\n  content: ' ';\n  background-color: #fff;\n  padding-left: 10px;\n  display: block;\n  height: 20px;\n  width: 20px;\n  border-radius:4px;\n  -webkit-transform: translate(5px);\n          transform: translate(5px);\n  -webkit-box-shadow: 0 0 2px #848484;\n          box-shadow: 0 0 2px #848484;\n  -webkit-transition: transform .3s;\n  -webkit-transition: -webkit-transform .3s;\n  transition: -webkit-transform .3s;\n  transition: transform .3s;\n  transition: transform .3s, -webkit-transform .3s;\n}\n.selection-btn.isActive::after{\n  -webkit-transform: translate(40px);\n          transform: translate(40px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("17717350", content, true, {});

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-container"
  }, [_c('div', {
    staticClass: "title-btn"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.value ? 'selection-btn isActive' : 'selection-btn',
    on: {
      "click": function($event) {
        return _vm.$emit('input', !_vm.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-detalhes',
  components: {
    SelectionBtn: __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default.a
  },
  data: function data() {
    return {
      ativo: false,
      passwordFieldType: 'password',
      rules: {
        name: [function (v) {
          return v.length > 0 || 'Insira um nome';
        }],
        login: [function (v) {
          return v.length > 0 || 'Insira um login';
        }],
        password: [function (v) {
          return v.length > 0 || 'Insira uma senha';
        }],
        email: [function (v) {
          return v.length > 0 || 'Insira um e-mail';
        }],
        phone: [function (v) {
          return !!v > 0 || 'Insira um telefone';
        }]
      }
    };
  },
  created: function created() {},

  methods: {
    updateUser: function updateUser() {
      if (this.$refs.itemForm.validate()) {
        this.$store.dispatch('updateUser');
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Verifique os campos em vermelho'
        });
      }
    },
    toggleActive: function toggleActive(value) {
      this.$store.commit('toggleUserActive');
    },
    updateName: function updateName(value) {
      this.$store.commit('updateUserName', value);
    },
    updateLogin: function updateLogin(value) {
      this.$store.commit('updateUserLogin', value);
    },
    updatePassword: function updatePassword(value) {
      this.$store.commit('updateUserPassword', value);
    },
    updatePhone: function updatePhone(value) {
      this.$store.commit('updateUserPhone', value);
    },
    updateEmail: function updateEmail(value) {
      this.$store.commit('updateUserEmail', value);
    },
    updateDepartment: function updateDepartment(value) {
      this.$store.commit('updateUserDepartment', value);
    },
    close: function close() {
      this.$store.commit('closeUser');
    },
    toggleVisibility: function toggleVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    }
  },
  computed: {
    loadingUserAction: function loadingUserAction() {
      return this.$store.getters.loadingUserAction;
    },
    user: function user() {
      return this.$store.getters.selectedUser;
    },

    userDetalhesModal: {
      get: function get() {
        return this.$store.getters.userVisible;
      },
      set: function set() {
        this.dataTags = '';
        this.$store.commit('toggleUserModal', false);
      }
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usuarioDetalhe__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usuarioDetalhe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usuarioDetalhe__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Usuários',
  components: {
    UsuarioDetalhes: __WEBPACK_IMPORTED_MODULE_0__usuarioDetalhe___default.a
  },
  data: function data() {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    };
  },

  methods: {
    next: function next() {
      this.$store.commit('nextPage');
      this.$store.dispatch('getUsers');
    },
    prev: function prev() {
      this.$store.commit('prevPage');
      this.$store.dispatch('getUsers');
    },
    refreshList: function refreshList() {
      this.$store.commit('changeItemsPerPage', this.ipp);
      this.$store.dispatch('getUsers');
    },
    itemEscolha: function itemEscolha(item) {
      this.$store.dispatch('selectUser', item);
    }
  },
  computed: {
    pagingText: function pagingText() {
      return 'mostrando de ' + ((this.$store.getters.currentPage - 1) * this.$store.getters.itemsPerPage + 1) + ' a ' + (this.$store.getters.currentPage * this.$store.getters.itemsPerPage > this.$store.getters.totalItems ? this.$store.getters.totalItems : this.$store.getters.currentPage * this.$store.getters.itemsPerPage) + ' de ' + this.$store.getters.totalItems;
    },
    users: function users() {
      return this.$store.getters.users;
    },
    currentPage: function currentPage() {
      return this.$store.getters.currentPage;
    },
    itemsPerPage: function itemsPerPage() {
      return this.$store.getters.itemsPerPage;
    },
    totalPages: function totalPages() {
      return this.$store.getters.totalPages;
    }
  },
  mounted: function mounted() {
    this.$store.commit('resetPage');
    this.$store.dispatch('getUsers');
  }
});

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{left:23px!important}.item-box{border:1px solid #bdbdbd;border-radius:15px;float:left}.outerDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}.titulo-detalhes{color:#e62039;font-size:21px}.titulo-detalhes .headline{font-size:25px}.titulo-detalhes-categoria{font-size:21px;padding-top:17px;color:#707983}p{color:#838789}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/conta/usuarioDetalhe.vue"],"names":[],"mappings":"AACA,sFACE,mBAAqB,CACtB,AACD,UACE,yBAA0B,AAC1B,mBAAoB,AACpB,UAAY,CACb,AACD,UACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAmB,CACpB,AAED,iBACI,cAAe,AACf,cAAgB,CACnB,AACD,2BACE,cAAgB,CACjB,AACD,2BACE,eAAgB,AAChB,iBAAkB,AAClB,aAAc,CACf,AACD,EACA,aAAc,CACb","file":"usuarioDetalhe.vue","sourcesContent":["\n.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{\r\n  left: 23px!important;\n}\n.item-box{\r\n  border: 1px solid #bdbdbd;\r\n  border-radius: 15px;\r\n  float: left;\n}\n.outerDiv{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: relative;\n}\r\n/* ajustes */\n.titulo-detalhes{\r\n    color: #e62039;\r\n    font-size: 21px;\n}\n.titulo-detalhes .headline{\r\n  font-size: 25px;\n}\n.titulo-detalhes-categoria{\r\n  font-size: 21px;\r\n  padding-top: 17px;\r\n  color: #707983\n}\np{\r\ncolor: #838789\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".tb-users{width:100%;border-collapse:collapse}.tb-users thead th{text-align:left;padding:5px}.tb-users tbody td{padding:5px}.tb-users thead tr{border-bottom:1px solid #999}.tb-users tbody tr{border-bottom:1px solid #ddd}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/conta/usuarios.vue"],"names":[],"mappings":"AACA,UAAU,WAAY,AAAC,wBAA0B,CAChD,AACD,mBAAmB,gBAAgB,WAAY,CAC9C,AACD,mBAAmB,WAAY,CAC9B,AACD,mBAAmB,4BAA6B,CAC/C,AACD,mBAAmB,4BAA6B,CAC/C","file":"usuarios.vue","sourcesContent":["\n.tb-users{width: 100%; border-collapse: collapse;\n}\n.tb-users thead th{text-align:left;padding:5px;\n}\n.tb-users tbody td{padding:5px;\n}\n.tb-users thead tr{border-bottom: 1px solid #999\n}\n.tb-users tbody tr{border-bottom: 1px solid #ddd\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("0d26b63a", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("3cab3988", content, true, {});

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(746),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.userDetalhesModal),
      callback: function($$v) {
        _vm.userDetalhesModal = $$v
      },
      expression: "userDetalhesModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v(_vm._s(_vm.user.id === '' ? 'Novo usuário' : _vm.user.nome))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.userDetalhesModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "itemForm",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "label": "Nome",
      "rules": _vm.rules.name,
      "value": typeof _vm.user.nome !== 'undefined' ? _vm.user.nome : '',
      "required": ""
    },
    on: {
      "input": _vm.updateName
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Login",
      "rules": _vm.rules.login,
      "value": _vm.user.login
    },
    on: {
      "input": _vm.updateLogin
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Login utilizado para acessar o sistema.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Senha",
      "rules": _vm.rules.password,
      "type": _vm.passwordFieldType,
      "value": _vm.user.senha
    },
    on: {
      "input": _vm.updatePassword
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordFieldType == 'password'),
      expression: "passwordFieldType == 'password'"
    }],
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "gray"
    },
    on: {
      "click": _vm.toggleVisibility
    },
    slot: "activator"
  }, [_vm._v("visibility")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordFieldType == 'text'),
      expression: "passwordFieldType == 'text'"
    }],
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "gray"
    },
    on: {
      "click": _vm.toggleVisibility
    },
    slot: "activator"
  }, [_vm._v("visibility_off")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Senha utilizado para acessar o sistema.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.rules.email,
      "value": _vm.user.email
    },
    on: {
      "input": _vm.updateEmail
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone",
      "rules": _vm.rules.phone,
      "value": _vm.user.telefone
    },
    on: {
      "input": _vm.updatePhone
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Departamento",
      "value": _vm.user.departamento
    },
    on: {
      "input": _vm.updateDepartment
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('p', [_vm._v("Ativo")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.user.active
    },
    on: {
      "input": _vm.toggleActive
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outline": "",
      "round": "",
      "color": "green",
      "disabled": _vm.loadingItemAction
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateUser()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Gravar")], 1)], 1)], 1), _vm._v(" "), (_vm.loadingItemAction) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "mb-5": ""
    }
  }, [_c('v-layout', {
    staticClass: "border-content mt-5 pa-4 mb-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "mb-5": ""
    }
  }, [_c('div', {
    staticClass: "company-header"
  }, [_vm._v("\r\n        Usuários\r\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "tb-users",
    attrs: {
      "cellspacing": "0",
      "cellspadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Login")]), _vm._v(" "), _c('th', [_vm._v("Telfone")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Departamento")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.telefone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.departamento))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "",
        "flat": "",
        "color": "grey lighten-1"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemEscolha(item.id)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("create")])], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "v-subheader theme--light"
  }, [_vm._v("itens por página")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "value": _vm.itemsPerPage,
      "bottom": "",
      "required": "",
      "items": _vm.comboList
    },
    on: {
      "change": _vm.refreshList
    },
    model: {
      value: (_vm.ipp),
      callback: function($$v) {
        _vm.ipp = $$v
      },
      expression: "ipp"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "pt-3 pr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.pagingText))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage > 1),
      expression: "currentPage > 1"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage < _vm.totalPages),
      expression: "currentPage < totalPages"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.itemEscolha(0)
      }
    }
  }, [_c('span', {
    staticClass: "pr-1"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_circle_outline")])], 1), _vm._v("\r\n        Novo Usuário\r\n      ")]), _vm._v(" "), _c('UsuarioDetalhes')], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.fc61455b1dba979c48a5.js